import { HttpClient } from '@angular/common/http';
import { inject, Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@environments/environment';
import { MICROSERVICES } from '@shared/constants/microservices';
import { Observable } from 'rxjs/internal/Observable';
import { SessionManagerService } from '../../../infrastructure/services/session-manager.service';
import { APIMSubscriptionKeyResponse, CreateApimUserRequest } from '../../developers/infrastructure/apim-authentication.interface';
import { APIMAuthenticationRepository } from './apim-authentication.repository';

@Injectable()
export class ApimAuthenticationApiService implements APIMAuthenticationRepository {
    readonly router = inject(Router);
    private sessionManager?: SessionManagerService;

    constructor(
        private injector: Injector,
        private http: HttpClient
    ) {}

    private setStorageToken(response: APIMSubscriptionKeyResponse) {
        const subscriptionKey = response.primaryKey;
        localStorage.setItem('subscription_key', subscriptionKey || '');
        this.getSessionManager().start();
    }

    private getSessionManager(): SessionManagerService {
        if (!this.sessionManager) {
            this.sessionManager = this.injector.get(SessionManagerService);
        }
        return this.sessionManager;
    }

    findOrCreateUserSubscriptionKey(request: CreateApimUserRequest): Observable<APIMSubscriptionKeyResponse> {
        return this.http.post<APIMSubscriptionKeyResponse>(`${environment.url}${MICROSERVICES.apimuser}/users`, request);
    }

    regenerateSubscriptionKey(userId: string): Observable<APIMSubscriptionKeyResponse> {
        return this.http.post<APIMSubscriptionKeyResponse>(
            `${environment.url}${MICROSERVICES.apimuser}/users/${userId}/subscriptions/regenerate`,
            {}
        );
        // .pipe(
        //     map((response: APIMSubscriptionKeyResponse) => {
        //         localStorage.setItem('subscription_key', response.primaryKey || '');
        //         return response;
        //     })
        // );
    }
}
